module.exports = __webpack_public_path__ + "img/h-page4-31.ebfaa124.png";